export default "__VITE_ASSET__61007a85__"